export default __webpack_public_path__ + "static/media/contactIcon1.9041ede0.png";